module.exports = __webpack_public_path__ + "img/logo.d938dde188a1813f61d22b478d9daecf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.jpg
// module id = 803
// module chunks = 0